let api = null;

const init = (axiosApi) => {
  api = axiosApi;
};

// Runtime feature flags, served behind auth at /api/config/features and
// fetched on boot via the app's authenticated axios instance.
const getFeatures = async () => {
  const response = await api.get('/config/features');
  return response.data; // { evChargingEnabled: boolean }
};

const ConfigService = {
  init,
  getFeatures,
};

export default ConfigService;
